var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50012 0C2.94931 0 1.68762 1.23365 1.68762 2.75V3.85H1.12512C0.504685 3.85 0.00012207 4.34335 0.00012207 4.95V9.9C0.00012207 10.5066 0.504685 11 1.12512 11H7.87512C8.49556 11 9.00012 10.5066 9.00012 9.9V4.95C9.00012 4.34335 8.49556 3.85 7.87512 3.85H7.31262V2.75C7.31262 1.23365 6.05093 0 4.50012 0ZM2.81262 2.75C2.81262 1.8403 3.56975 1.1 4.50012 1.1C5.4305 1.1 6.18762 1.8403 6.18762 2.75V3.85H2.81262V2.75ZM7.87625 9.9H5.06262V8.6471C5.39731 8.45625 5.62512 8.10535 5.62512 7.7C5.62512 7.09335 5.12056 6.6 4.50012 6.6C3.87968 6.6 3.37512 7.09335 3.37512 7.7C3.37512 8.1048 3.60293 8.45625 3.93762 8.6471V9.9H1.12512V4.95H7.87512L7.87625 9.9Z",
    fill: "#D9B164"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockicon);
export default __webpack_public_path__ + "static/media/lockicon.940a0197dff5b7523d74dbe74a82a605.svg";
export { ForwardRef as ReactComponent };